import React, {useEffect, useState} from 'react'
import {Auth} from "../../utils/Auth";
import './Leaderboard.scss';
import {RequestWallet} from "../../request/RequestWallet";
import LeaderboardTable from "../../containers/Table/LeaderboardTable/LeaderboardTable";
import Spinner from "../../components/Spinner/Spinner";
import {useTranslation} from "react-i18next";
import {round} from "../../utils/services";
import Skeleton from '@mui/material/Skeleton';

const LeaderboardSkeletonRow = () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #f1f5f9', backgroundColor: '#fff' }}>
        <Skeleton animation="wave" variant="text" width={20} height={24} />
        <Skeleton animation="wave" variant="text" width={120} height={20} />
        <Skeleton animation="wave" variant="text" width={80} height={20} />
        <Skeleton animation="wave" variant="rounded" width={70} height={32} sx={{ borderRadius: '8px' }} />
    </div>
);


function Leaderboard() {
    const {t} = useTranslation();
    const [classement,setClassement] = useState(null)
    const requestWallet = new RequestWallet();
    const [isLoading,setIsLoading] = useState(false);
    const [timeRemaining, setTimeRemaining] = useState('');
    const auth = new Auth();

    useEffect( ()=>{
        getClassement()
    },[])

    async function getClassement(){
        const username = await auth.getUsername();
        const resp = await requestWallet.getClassement(username);
        await setClassement(resp.data)
        setIsLoading(true)
    }

    useEffect(() => {
        function startTimer() {
            let now = new Date();
            let target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 22, 0, 0, 0);

            if (now.getTime() > target.getTime()) {
                target.setDate(target.getDate() + 1);
            }

            let diff = target - now;
            let hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= hours * 1000 * 60 * 60;
            let minutes = Math.floor(diff / 1000 / 60);
            diff -= minutes * 1000 * 60;
            let seconds = Math.floor(diff / 1000);
            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;

            setTimeRemaining(`${hours}:${minutes}:${seconds}`);
            setTimeout(startTimer, 1000);
        }

        startTimer();
    }, []);

    return (
        <div className="containerPage">
            <div className="card">
                <div className="leaderboard-header">
                    <h1 className='mb-0'>{t('leaderboard.general')}</h1>
                    <div className="timer-pill">
                        <span className="timer-label">{t('leaderboard.timeBeforeUpdate')}</span>
                        <span className="timer-value">{timeRemaining}</span>
                    </div>
                </div>
                {
                    isLoading ?
                        <>
                            <div key="loaded" className="podium-container loaded">
                                {classement.leaderboard[1] &&
                                    <div className="podium-step step-2">
                                        <div className="podium-info">
                                            <p className={`podium-name ${auth.getUsername() === classement.leaderboard[1].username ? 'font-bold' : ''}`}>{classement.leaderboard[1].username}</p>
                                            <p className="podium-value">{round(classement.leaderboard[1].totalValue, 2)} $</p>
                                        </div>
                                        <div className="podium-block block-2">2</div>
                                    </div>
                                }
                                {classement.leaderboard[0] &&
                                    <div className="podium-step step-1">
                                        <div className="podium-info">
                                            <p className={`podium-name ${auth.getUsername() === classement.leaderboard[0].username ? 'font-bold' : ''}`}>{classement.leaderboard[0].username}</p>
                                            <p className="podium-value">{round(classement.leaderboard[0].totalValue, 2)} $</p>
                                        </div>
                                        <div className="podium-block block-1">1</div>
                                    </div>
                                }
                                {classement.leaderboard[2] &&
                                    <div className="podium-step step-3">
                                        <div className="podium-info">
                                            <p className={`podium-name ${auth.getUsername() === classement.leaderboard[2].username ? 'font-bold' : ''}`}>{classement.leaderboard[2].username}</p>
                                            <p className="podium-value">{round(classement.leaderboard[2].totalValue, 2)} $</p>
                                        </div>
                                        <div className="podium-block block-3">3</div>
                                    </div>
                                }
                            </div>
                            {
                                classement.leaderboard.length>0 && <LeaderboardTable data={classement}/>
                            }
                        </>
                        :
                        <>
                            <div key="skeleton" className="podium-container" style={{ opacity: 0.5 }}>
                                <div className="podium-step step-2">
                                    <div className="podium-info">
                                        <Skeleton animation="wave" variant="text" width={80} height={20} />
                                        <Skeleton animation="wave" variant="text" width={60} height={20} />
                                    </div>
                                    <div className="podium-block block-2"></div>
                                </div>
                                <div className="podium-step step-1">
                                    <div className="podium-info">
                                        <Skeleton animation="wave" variant="text" width={80} height={20} />
                                        <Skeleton animation="wave" variant="text" width={60} height={20} />
                                    </div>
                                    <div className="podium-block block-1"></div>
                                </div>
                                <div className="podium-step step-3">
                                    <div className="podium-info">
                                        <Skeleton animation="wave" variant="text" width={80} height={20} />
                                        <Skeleton animation="wave" variant="text" width={60} height={20} />
                                    </div>
                                    <div className="podium-block block-3"></div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden', border: '1px solid #cbd5e1' }}>
                                {[...Array(6)].map((_, i) => <LeaderboardSkeletonRow key={i} />)}
                            </div>
                        </>
                }
            </div>
        </div>

    )
}

export default Leaderboard